import React, {useEffect, createContext, useReducer} from 'react';
import { FETCH_DATA_REQUEST, DISPLAY_ERROR_MESSAGE, FETCH_DATE_CONFIG,
        FETCH_REMARK_OPTIONS, RESET_MODEL_AND_ERROR_FLAGS, SET_SUBMIT_SUCCESS, SET_LOADING_FALSE } from '../actions/actionTypes';
import { fetchMetaData, fetchRemarksOptions } from '../actions/actionSelectors';
import { calendarchangeRequestReducer } from '../actions/calendar-changerequest-reducer';

const initialState = {
    sessionTimeoutLimit: null,
    remarksOptions: [],
    idleTimeoutLimit: null,
    errorMessage: "",   
    isError: false,
    modelHeaderTitle: null,
    showModel: false,
    isSuccessfullySaved: false,
    isLoading : false
}
    
export const CalendarChangeRequestContext = createContext();

export function CalendarChangeRequestProvider(props) {

    const [state, dispatch] = useReducer(calendarchangeRequestReducer, initialState);
    const { sessionTimeoutLimit, idleTimeoutLimit, remarksOptions, isLoading,
        errorMessage, isError, modelHeaderTitle, showModel, isSuccessfullySaved } = state;
    
    useEffect(() => {
        props.setSelectedNavItem(window.location.pathname.replace(/[/]/g, ''));   
        dispatch({ type: FETCH_DATA_REQUEST, payload: { isError: false, errorMessage: "" } });     
        async function fetchMetaDataAsync() {
            await fetchMetaData()
                .then((data) => {
                    dispatch({
                        type: FETCH_DATE_CONFIG,
                        payload: {                            
                            sessionTimeoutLimit: data.sessionTimeoutLimit ? +(data.sessionTimeoutLimit) : null,
                            idleTimeoutLimit: data.sessionTimeoutLimit ? +(data.idleTimeoutLimit) : null
                        }
                    });
                   if(data.sessionTimeoutLimit && data.idleTimeoutLimit)
                    { 
                        fetchRemarkOptionsHandler();
                    }
                })
                .catch((error) => { errorOrWarningHandler(true, "wentwrong", true, "change_request_action"); })
        }
        fetchMetaDataAsync();               
    }, []);  

    const resetSubmittedAndErrorFlags = () => {
        dispatch({ type: RESET_MODEL_AND_ERROR_FLAGS }); 
        props.setLogoutFalse();
    }  
    
    const setSubmitSuccess = () => { dispatch({ type: SET_SUBMIT_SUCCESS, payload:{ modelHeaderTitle: "change_request_action" } }); }   
    
    const setIsLoading = (flag) => { dispatch({ type: SET_LOADING_FALSE, payload: { isLoading : flag} }); }    
    
    const errorOrWarningHandler = (isModelError, errorModelMessage, showErrorModel, modelHeaderTitleError) => {
        dispatch({
            type: DISPLAY_ERROR_MESSAGE,
            payload: {
                isError: isModelError,
                errorMessage: errorModelMessage,                
                showModel: showErrorModel,
                modelHeaderTitle: modelHeaderTitleError              
            }
        });
    }   

    const fetchRemarkOptionsHandler = async () => {
        await fetchRemarksOptions()
            .then((data) => {
                dispatch({
                    type: FETCH_REMARK_OPTIONS,
                    payload: {
                        remarksOptions: data && typeof(data) !== 'string' ? data : null
                    }
                });                
            })
            .catch((error) => { errorOrWarningHandler(true, "wentwrong", true, "change_request_action"); })
    }

    const handleConfirmationYesClick = () => { if(props.isLogout) { props.clearSessionData(); }}
    
    const provider = {
        remarksOptions,
        sessionTimeoutLimit,
        idleTimeoutLimit,
        errorMessage, 
        isError,
        modelHeaderTitle,
        showModel,
        resetSubmittedAndErrorFlags,        
        handleConfirmationYesClick,
        errorOrWarningHandler,
        setSubmitSuccess, 
        isSuccessfullySaved,
        isLoading,
        setIsLoading
    };

    return (
        <CalendarChangeRequestContext.Provider value={provider}>
            {props.children}
        </CalendarChangeRequestContext.Provider>
    );
}
